import { doGraphqlRequest } from 'ducks/requests'
import graphql from '../api'
import * as types from '../types'

const searchProductsQuery = `
  query ShopifySearchProducts(
    $query: String!
  ) {
    products(first: 10, query: $query) {
      edges {
        node {
          id
          totalVariants
          title
          featuredImage {
            id
            originalSrc
          }
          hasOnlyDefaultVariant
          variants(first: 25) {
            edges {
              node {
                id
                displayName
                image {
                  id
                  height
                  width
                  originalSrc
                }
                inventoryQuantity
                price
                sku
              }
            }
          }
        }
      }
    }
  }
`

const doSearchProducts = (integrationId, title) => dispatch => {
  const variables = { query: `title: ${title}` }
  dispatch(
    doGraphqlRequest(
      types.SEARCH_PRODUCTS_REQUEST,
      searchProductsQuery,
      variables,
      {
        graphqlFunc: graphql(integrationId),
      }
    )
  )
}

export default doSearchProducts
